module.exports = __webpack_public_path__ + "img/11.e0cd2876.jpg";